var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "16",
        viewBox: "0 0 14 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        { attrs: { id: "calendar-day", "clip-path": "url(#clip0_875_25680)" } },
        [
          _c("path", {
            attrs: {
              id: "Vector",
              d: "M4 0.125C4.55312 0.125 5 0.564893 5 1.10938V2.09375H9V1.10938C9 0.564893 9.44687 0.125 10 0.125C10.5531 0.125 11 0.564893 11 1.10938V2.09375H12.5C13.3281 2.09375 14 2.75513 14 3.57031V5.04688H0V3.57031C0 2.75513 0.671875 2.09375 1.5 2.09375H3V1.10938C3 0.564893 3.44688 0.125 4 0.125ZM0 6.03125H14V14.3984C14 15.2136 13.3281 15.875 12.5 15.875H1.5C0.671875 15.875 0 15.2136 0 14.3984V6.03125ZM2.5 8C2.225 8 2 8.22148 2 8.49219V11.4453C2 11.716 2.225 11.9375 2.5 11.9375H5.5C5.775 11.9375 6 11.716 6 11.4453V8.49219C6 8.22148 5.775 8 5.5 8H2.5Z",
              fill: "#717986",
            },
          }),
        ]
      ),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_875_25680" } }, [
          _c("rect", {
            attrs: {
              width: "14",
              height: "15.75",
              fill: "white",
              transform: "translate(0 0.125)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }